var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"chevron"),React.createElement("g",{"id":"Symbols","key":1},React.createElement("g",{"id":"Form-Field-Select"},React.createElement("polygon",{"id":"Fill-1","points":"9.21 9.9 18.41 1.09 17.37 0 9.21 7.8 1.04 0 0 1.09 9.21 9.9","style":{"fillRule":"evenodd"}})))]);
}

Chevron.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 18.41 9.9"};

module.exports = Chevron;

Chevron.default = Chevron;
